import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { DomainEntity, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { EPM_Domain_Events_Action_Category__Category_ToUrlString, labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { append as append_1, map as map_1, head, tail, length, isEmpty, empty, ofArray, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { Humanize_timeSpan, EPM_Domain_Events_Action_Category__Category_ToProperString, EPM_Domain_Events_Maturity__Maturity_ToProperString, EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString } from "../Prelude.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { adminContent, ByCell, Labels, UserCell, dateTimeCell, EntityProperty, EntityName } from "./Prelude.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { count, many } from "../Api/Activities.fs.js";
import { StartActivity, Export, ChangeAction, ChangeMaturity, ChangeCategory, SetExpectedDate, SetEstimatedCompletionTime, UnSign, SetActualCompletionTime, AssignUser, Update } from "../Modals/Activity.fs.js";
import { Components_UnDelete, Components_Delete, Components_ExportLabels, Components_ChangeLabels } from "../Modals/Modal.fs.js";
import { many as many_1 } from "../Api/Entities.fs.js";

function searchParam(search) {
    if (isNullOrWhiteSpace(search)) {
        return new FSharpResult$2(1, ["search"]);
    }
    else {
        return new FSharpResult$2(0, [["search", search]]);
    }
}

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(detail) {
    if (isNullOrWhiteSpace(detail)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["detail", detail]]);
    }
}

function actionParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["actionId"]);
    }
    else {
        return new FSharpResult$2(0, [["actionId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["requiredLabels"]);
    }
    else {
        return new FSharpResult$2(0, [["requiredLabels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function columns(projectId, category) {
    return ofArray([new Column("entity", "Entity", new FilterType(0, [searchParam])), new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("maturity", "Maturity", undefined), new Column("category", "Category", undefined), new Column("action", "Action", new FilterType(1, [projectId, new DomainEntities(11, []), singleton(["category", EPM_Domain_Events_Action_Category__Category_ToUrlString(category)]), actionParam])), new Column("actionMaturity", "Action Maturity", undefined), new Column("actionCategory", "Action Category", undefined), new Column("createdDate", "Created Date", undefined), new Column("estimatedCompletionDate", "Estimated Completion Date", undefined), new Column("actualCompletionDate", "Actual Completion Date", undefined), new Column("estimatedCompletionTime", "Estimated Completion Time", undefined), new Column("actualCompletionTime", "Actual Completion Time", undefined), new Column("assignedUser", "Assigned User", undefined), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(5, []), singleton(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(category)]), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function rowRender(projectId, activity) {
    let matchValue, te, iconProps, elems_1, spanProps, elems_2, elems, xs_4;
    return new Row(activity.Id, ofArray([new Cell("entity", (matchValue = activity.TargetEntity, (matchValue == null) ? defaultOf() : ((te = matchValue, activity.IsAutoGenerated ? ((iconProps = ofArray([(elems_1 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-exclamation"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_1))]), ["title", "This is an AutoGenerated suggestion"]]), (spanProps = singleton((elems_2 = [`${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(te.EntityType)}: `, createElement(EntityName, {
        projectId: projectId,
        entityType: te.EntityType,
        entityId: te.EntityId,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])), createElement("span", createObj(ofArray([["className", "icon-text"], (elems = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => iconProps))))), createElement("span", createObj(toList(delay(() => spanProps))))], ["children", reactApi.Children.toArray(Array.from(elems))])])))))) : ((xs_4 = [`${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(te.EntityType)}: `, createElement(EntityName, {
        projectId: projectId,
        entityType: te.EntityType,
        entityId: te.EntityId,
    })], react.createElement(react.Fragment, {}, ...xs_4))))))), new Cell("name", defaultArg(map((value_9) => value_9, activity.Name), defaultOf())), new Cell("detail", defaultArg(map((value_12) => value_12, activity.Detail), defaultOf())), new Cell("action", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(11, []),
        entityId: unwrap(activity.ActionId),
    })), new Cell("maturity", defaultArg(map(EPM_Domain_Events_Maturity__Maturity_ToProperString, activity.Maturity), defaultOf())), new Cell("actionMaturity", createElement(EntityProperty, {
        projectId: projectId,
        entityType: new DomainEntities(11, []),
        entityId: unwrap(activity.ActionId),
        map: (entity) => ((entity.tag === 11) ? EPM_Domain_Events_Maturity__Maturity_ToProperString(entity.fields[0].Maturity) : defaultOf()),
    })), new Cell("category", defaultArg(map(EPM_Domain_Events_Action_Category__Category_ToProperString, activity.Category), defaultOf())), new Cell("actionCategory", createElement(EntityProperty, {
        projectId: projectId,
        entityType: new DomainEntities(11, []),
        entityId: unwrap(activity.ActionId),
        map: (entity_1) => ((entity_1.tag === 11) ? EPM_Domain_Events_Action_Category__Category_ToProperString(entity_1.fields[0].Category) : defaultOf()),
    })), new Cell("estimatedCompletionTime", defaultArg(map(Humanize_timeSpan, activity.EstimatedCompletionTime), defaultOf())), new Cell("actualCompletionTime", defaultArg(map(Humanize_timeSpan, activity.ActualCompletionTime), defaultOf())), new Cell("createdDate", defaultArg(map(dateTimeCell, activity.CreatedDate), defaultOf())), new Cell("estimatedCompletionDate", defaultArg(map(dateTimeCell, activity.ExpectedCompletionDate), defaultOf())), new Cell("actualCompletionDate", defaultArg(map(dateTimeCell, activity.CompletedOn), defaultOf())), new Cell("assignedUser", defaultArg(map((userId) => createElement(UserCell, {
        projectId: projectId,
        userId: userId,
    }), activity.AssignedToUserId), defaultOf())), new Cell("labels", createElement(Labels, {
        labels: activity.Labels,
    })), new Cell("lastModifiedOn", dateTimeCell(activity.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: activity.LastModifiedBy,
    }))]));
}

export function Activities(activitiesInputProps) {
    let actions, activities, activities_1;
    const category = activitiesInputProps.category;
    const projectId = activitiesInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedActivities = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const showAutoGenerated = patternInput_3[0];
    const setShowAutoGenerated = patternInput_3[1];
    const patternInput_4 = reactApi.useState("");
    const patternInput_5 = reactApi.useState(empty());
    const filters = patternInput_5[0];
    const initialFilters = toList(delay(() => append(singleton_1(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(category)]), delay(() => {
        let matchValue;
        return append((matchValue = showAutoGenerated, (matchValue != null) ? singleton_1(["auto-generated", toString(matchValue)]) : (empty_1())), delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1())));
    }))));
    let columns_1;
    const dependencies_1 = [projectId, category];
    columns_1 = reactApi.useMemo(() => columns(projectId, category), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_4[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: EPM_Domain_Events_Action_Category__Category_ToProperString(category),
        columns: columns_1,
        initialFilters: initialFilters,
        onFiltersChange: patternInput_5[1],
        fetchData: (activityParams) => many(projectId, empty(), activityParams),
        fetchCount: (activityParams_1) => count(projectId, activityParams_1),
        rowRender: (activity) => rowRender(projectId, activity),
        refresh: patternInput_4[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedActivities);
    const isMoreThan1 = length(selectedActivities) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", (showAutoGenerated != null) ? (showAutoGenerated ? "Hide AutoGenerated Only" : "Show All") : "Show AutoGenerated Only"], ["onClick", (_arg) => {
        if (showAutoGenerated != null) {
            if (showAutoGenerated) {
                setShowAutoGenerated(false);
            }
            else {
                setShowAutoGenerated(undefined);
            }
        }
        else {
            setShowAutoGenerated(true);
        }
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg_1) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_2) => {
        setAction("start");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_3) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Action"], ["onClick", (_arg_4) => {
        setAction("changeAction");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Category"], ["onClick", (_arg_5) => {
        setAction("changeCategory");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Maturity"], ["onClick", (_arg_6) => {
        setAction("changeMaturity");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign To User"], ["onClick", (_arg_7) => {
        setAction("assignToUser");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Set Expected Date"], ["onClick", (_arg_8) => {
        setAction("setExpectedDate");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Set Estimated Time"], ["onClick", (_arg_9) => {
        setAction("setEstimatedTime");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Set Actual Time"], ["onClick", (_arg_10) => {
        setAction("setActualTime");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "UnSign"], ["onClick", (_arg_11) => {
        setAction("unSign");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_12) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedActivities) ? true : showDeleted]]))))), delay(() => append(showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_13) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedActivities)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_14) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedActivities)]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export"], ["onClick", (_arg_15) => {
        setAction("export");
    }]]))))), delay(() => singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export Labels"], ["onClick", (_arg_16) => {
        setAction("exportLabels");
    }]]))))))))))))))))))))))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedActivities) ? (isEmpty(tail(selectedActivities)) ? createElement(Update, {
        projectId: projectId,
        activity: head(selectedActivities),
        close: close,
    }) : undefined) : undefined) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map_1((activity_2) => [new DomainEntity(12, [activity_2]), activity_2.Labels], selectedActivities),
        close: close,
    }) : ((actions === "assignToUser") ? createElement(AssignUser, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "setActualTime") ? createElement(SetActualCompletionTime, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "unSign") ? createElement(UnSign, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "setEstimatedTime") ? createElement(SetEstimatedCompletionTime, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "setExpectedDate") ? createElement(SetExpectedDate, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "changeCategory") ? createElement(ChangeCategory, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "changeMaturity") ? createElement(ChangeMaturity, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "changeAction") ? createElement(ChangeAction, {
        projectId: projectId,
        activities: selectedActivities,
        close: close,
    }) : ((actions === "export") ? createElement(Export, {
        projectId: projectId,
        filters: append_1(filters, initialFilters),
        close: () => {
            close(false);
        },
    }) : ((actions === "exportLabels") ? createElement(Components_ExportLabels, {
        entityType: new DomainEntities(5, []),
        countApi: () => count(projectId, filters),
        fetchApi: (apiParams_1) => many_1(new DomainEntities(5, []), projectId, apiParams_1, filters),
        close: () => {
            close(false);
        },
    }) : ((actions === "delete") ? ((activities = map_1((Item) => (new DomainEntity(12, [Item])), selectedActivities), createElement(Components_Delete, {
        projectId: projectId,
        entities: activities,
        close: close,
    }))) : ((actions === "unDelete") ? ((activities_1 = map_1((Item_1) => (new DomainEntity(12, [Item_1])), selectedActivities), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: activities_1,
        close: close,
    }))) : createElement(StartActivity, {
        projectId: projectId,
        initialCategory: category,
        close: close,
    })))))))))))))))) : undefined);
}

